import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  Collapse,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledAlert,
  UncontrolledDropdown,
} from "reactstrap";

const FileLeftBar = () => {
  const [isOpen, setIsOpen] = useState(true);

  const toggle = () => setIsOpen(!isOpen);

  // HarmanaGEL Sistemine Özel Klasör Verileri
  const filesData = [
    { text: "Blog Görselleri", isPinned: true },
    { text: "Sürücü Evrakları", isPinned: false },
    { text: "Firma Faturaları", isPinned: false },
    { text: "Sistem Belgeleri", isPinned: false },
  ];

  // Alt Menü Kategorileri
  const filemanagerData = [
    { text: "Son Yüklenenler", icon: "mdi mdi-clock-outline font-size-16 text-info me-2" },
    { text: "Önemli Dosyalar", icon: "mdi mdi-star-outline font-size-16 text-warning me-2", badge: true },
    { text: "Silinmiş Öğeler", icon: "mdi mdi-trash-can-outline font-size-16 text-danger me-2" },
  ];

  return (
    <React.Fragment>
      <Card className="filemanager-sidebar me-md-2 shadow-sm border-0">
        <CardBody>
          <div className="d-flex flex-column h-100">
            <div className="mb-4">
              
              {/* YENİ DOSYA YÜKLE BUTONU */}
              <div className="mb-3">
                <UncontrolledDropdown>
                  <DropdownToggle className="btn btn-primary w-100 btn-rounded shadow-sm" type="button">
                    <i className="mdi mdi-cloud-upload me-1"></i> Yeni Yükle
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem href="#"><i className="bx bx-folder me-1 text-warning"></i> Yeni Klasör</DropdownItem>
                    <DropdownItem href="#"><i className="bx bx-file me-1 text-primary"></i> Dosya Yükle</DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>

              {/* KLASÖR LİSTESİ */}
              <ul className="list-unstyled categories-list">
                <li>
                  <div className="custom-accordion">
                    <Link
                      className="text-body fw-medium py-1 d-flex align-items-center"
                      onClick={toggle}
                      to="#"
                    >
                      <i className="mdi mdi-folder font-size-16 text-warning me-2"></i>{" "}
                      Sistem Dizini{" "}
                      <i
                        className={
                          isOpen
                            ? "mdi mdi-chevron-up accor-down-icon ms-auto"
                            : "mdi mdi-chevron-down accor-down-icon ms-auto"
                        }
                      />
                    </Link>
                    <Collapse isOpen={isOpen}>
                      <div className="card border-0 shadow-none ps-2 mb-0">
                        <ul className="list-unstyled mb-0">
                          {filesData.map((item, index) => (
                            <li key={index}>
                              <Link to="#" className="d-flex align-items-center text-muted hover-primary">
                                <span className="me-auto">{item.text}</span>
                                {item.isPinned && <i className="mdi mdi-pin ms-auto text-primary"></i>}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </Collapse>
                  </div>
                </li>
                
                {/* ALT KATEGORİLER */}
                {filemanagerData.map((item, index) => (
                  <li key={index} className="mt-2">
                    <Link to="#" className="text-body d-flex align-items-center hover-primary">
                      <i className={item.icon}></i> <span className="me-auto text-muted">{item.text}</span>
                      {item.badge && <span className="badge bg-success rounded-pill ms-2">Yeni</span>}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* SİSTEM BİLGİ KARTI */}
            <div className="mt-auto">
              <UncontrolledAlert color="success" className="alert-dismissible fade show px-3 mb-0 border-0 shadow-sm">
                <div className="mb-3">
                  <i className="bx bx-shield-quarter h1 text-success"></i>
                </div>
                <div>
                  <h5 className="text-success">Sistem Güvende</h5>
                  <p className="small mb-2">Tüm dosyalarınız günlük olarak HarmanaGEL sunucularında yedeklenmektedir.</p>
                  <div className="text-center">
                    <button type="button" className="btn btn-link p-0 text-decoration-none text-success fw-medium">
                      Ayarları Gör <i className="mdi mdi-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </UncontrolledAlert>
            </div>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default FileLeftBar;